import { IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';
import { VCenteredFlex } from '../foundation/Flex';

export const IconButtonWhiteBG = styled(IconButton)`
    background: white;
    margin-top: 1rem;
    border-radius: 5px;
    border: 1px solid ${props => props.theme.palette.secondary.main}a8;
`;

export const TagStyle = styled(VCenteredFlex)`
    border-radius: 5px;
    border: solid 1px #eeeeefa1;
    padding: 0.5rem;
    margin-inline-end: 0.5rem;
    margin-top: 0.5rem;
    display: inline-flex;
    background: #ffffff;
`;

export const AccountStats = styled(VCenteredFlex)`
    justify-content: space-evenly;
    color: white;
    background: ${props => props.theme.palette.secondary.main};
    padding: 1rem;
    border-radius: 5px;
    box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
    hr {
        background-color: white;
        margin: 0 1rem;
    }
`;
